import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';

export function useMarketOverview(clientId: string | undefined) {
  return useQuery({
    queryKey: ['client', clientId, 'market', 'overview'],
    queryFn: () => apiClient.market.getOverview(clientId!),
    enabled: !!clientId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export function useMarketSegments(clientId: string | undefined) {
  return useQuery({
    queryKey: ['client', clientId, 'market', 'segments'],
    queryFn: () => apiClient.market.getSegments(clientId!),
    enabled: !!clientId,
    staleTime: 5 * 60 * 1000,
  });
}

export function usePortfolioPosition(clientId: string | undefined) {
  return useQuery({
    queryKey: ['client', clientId, 'market', 'position'],
    queryFn: () => apiClient.market.getPosition(clientId!),
    enabled: !!clientId,
    staleTime: 5 * 60 * 1000,
  });
}

export function useMarketChannels(clientId: string | undefined) {
  return useQuery({
    queryKey: ['client', clientId, 'market', 'channels'],
    queryFn: () => apiClient.market.getChannels(clientId!),
    enabled: !!clientId,
    staleTime: 5 * 60 * 1000,
  });
}

export function useMarketCosts(clientId: string | undefined) {
  return useQuery({
    queryKey: ['client', clientId, 'market', 'costs'],
    queryFn: () => apiClient.market.getCosts(clientId!),
    enabled: !!clientId,
    staleTime: 5 * 60 * 1000,
  });
}

export function useMarketSeasonality(clientId: string | undefined) {
  return useQuery({
    queryKey: ['client', clientId, 'market', 'seasonality'],
    queryFn: () => apiClient.market.getSeasonality(clientId!),
    enabled: !!clientId,
    staleTime: 5 * 60 * 1000,
  });
}
